/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable promise/catch-or-return */
'use es6';

import { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { AuthedI18nContext, PublicI18nContext } from '../context/I18nContext';
import { isAppAuthSelector } from '../selectors/ConfigSelectors';
export const useTranslations = (translations, shouldLoadTranslations = true) => {
  const [isReady, setIsReady] = useState(false);
  const i18nContext = useSelector(reduxState => isAppAuthSelector(reduxState) ? AuthedI18nContext : PublicI18nContext);
  const {
    i18nLoader
  } = useContext(i18nContext);
  useEffect(() => {
    if (shouldLoadTranslations) {
      i18nLoader.register(translations).then(() => {
        setIsReady(true);
      });
    }
  }, [shouldLoadTranslations]);
  return {
    isReady
  };
};